import { render, staticRenderFns } from "./groupSwiper.vue?vue&type=template&id=8e378240&scoped=true&"
import script from "./groupSwiper.vue?vue&type=script&lang=js&"
export * from "./groupSwiper.vue?vue&type=script&lang=js&"
import style0 from "./groupSwiper.vue?vue&type=style&index=0&id=8e378240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e378240",
  null
  
)

export default component.exports